<template>
  <el-table class="m-b" :data="supplierList">
    <el-table-column label="序号" type="index"></el-table-column>
    <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
    <el-table-column label="报价状态" :formatter="formatter1"></el-table-column>
    <el-table-column label="报价时间" :formatter="formatter2"></el-table-column>
  </el-table>
</template>

<script>
import store from '@/store'
import dayjs from 'dayjs'
export default {
  props: {
    inquireId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      supplierList: []
    }
  },
  created() {
    store
      .dispatch('listSupplierByInquireId', {
        inquireId: this.inquireId
      })
      .then((res) => {
        this.supplierList = res
      })
  },
  methods: {
    formatter1(row) {
      return row.quote ? '已报价' : '未报价'
    },
    formatter2(row) {
      return row.quoteTime && dayjs(row.quoteTime).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style></style>
